module.exports = __webpack_public_path__ + "media/images/team/cathrin-56cae577c59263724c073774dc182efd.jpg";